<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 4/1/2021
  -->

<template>
	<div class="mb-4">
		<div class="mb-2 row mx-0">
			<div><slot></slot></div>
			<div class="layout-spacer"></div>
			<ToolTipView :analyticsProps="tooltipAnalyticsProps"  v-if="shouldShowTooltip">
				<slot name="tooltip">{{tooltipText}}</slot>
			</ToolTipView>
		</div>
		<hr/>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "PanelTitle",
	components: {ToolTipView},
	extends: BaseComponent,
	props:{
		tooltipText: String,
		tooltipAnalyticsProps: Object
	},

	computed:{
		shouldShowTooltip(){
			return this.tooltipText || this.$slots.tooltip
		}
	}
}
</script>

<style lang="scss">

</style>
